import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as FwDatas from "../FwDatas.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as i18n from "../i18n.ts";
import * as forms from "../util/forms.js";
import {getCache} from "../server/objects/BudgetBeans.js";
export {init}

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

Html.registerWidget('budget/widget-transactionline',{init:init})

function getTransaction(metaId){
  var transaction = budgetTransactionCache.get(metaId)
  if(transaction===null){
    metaId = metaId.substring(0,metaId.lastIndexOf('_'));
    transaction = budgetTransactionCache.get(metaId)
  }
  return transaction;
}


actionMenu.register({
  budgetpickcategory:function(){
    var 
      metaId = this.metaId(),
      transaction = getTransaction(metaId),
      catMenuBuilder = cat=>{
        return {
          emoji:cat.emoji,
          title:cat.name,
          onclick:"budgetpickedcategory|"+metaId+"|"+cat.metaId,
          selected:cat.metaId===transaction.budgetCategoryId
        }
      },
      categories = budgetCategoryCache.filtered(),
      menu = [{i18nkey:"budget.expense"}]
        .concat(categories.filter(cat=>cat.budgetTransactionType==="EXPENSE").map(catMenuBuilder))
        .concat([{i18nkey:"budget.revenue"}])
        .concat(categories.filter(cat=>cat.budgetTransactionType==="REVENUE").map(catMenuBuilder));
    
    return {
      menu:menu
    }
  },
  budgetpickpaymentmethod:function(){
    var transaction = getTransaction(this.metaId())
    return {
      menu:budgetPaymentMethodCache.filtered().map(cat=>{
        return {
          emoji:cat.emoji,
          title:cat.name,
          onclick:"budgetpickedpaymentmethod|"+this.metaId()+"|"+cat.metaId
        }
      })
    }
  },  
  budgetpickaccount:function(){
    var 
      transaction = getTransaction(this.metaId()),
      accountmenu = FwDatas.getFamily().members.map(member=>{
        return {
          img: member.thumb(),
          iconclass:"rounded",
          title:member.firstName,
          onclick:"budgetpickedaccount|"+this.metaId()+"|"+member.accountId
        }
      });
    return {menu:accountmenu}
  
  }
})
Html.register({
  budgetpickedcategory:function(transactionId,budgetCategoryId){
    var cat = budgetCategoryCache.get(budgetCategoryId)
    checkUpdateOption({budgetCategoryId:budgetCategoryId,budgetTransactionType:cat.budgetTransactionType,metaId:transactionId})
  },
  budgetpickedpaymentmethod:function(transactionId,paymentMethodId){
    checkUpdateOption({paymentMethodId:paymentMethodId,metaId:transactionId})
  },
  budgetpickedaccount:function(transactionId,relatedAccountId){
    checkUpdateOption({relatedAccountId:relatedAccountId,metaId:transactionId})
  }
})
function init(trNode){
  var 
    metaId = trNode.metaId();
  
  trNode.on('keypress',function(event){
    if(event.keyCode===10 || event.keyCode===13){
      event.preventDefault();
      $(event.target).blur();
    }
  })
  trNode.find('[data-name], input').on('blur',function(){
    var 
      data = {metaId:metaId},
      node = $(this);
    
    if(node.attr('type')==='amount'){
      var value = Math.abs(node.amountValue())
      if(isNaN(value)||value===0){
        forms.markInvalid(node,i18n.get('budget.transactionerrors.amount'))
        return;
      }
      data[node.attr('name')] = Math.abs(node.amountValue())
    }else if(node.attr('type')==='date'){
      var 
        value = node.dateValue(),
        original = getTransaction(metaId).startDate;
      
      value = new Date(value.toISOString().substring(0,10)+original.toISOString().substring(10))
      
        
      data[node.attr('name')] = value
    }else if(node.attr('type')==='text'){
      data[node.attr('name')] = node.val()
    }
    checkUpdateOption(data)
    
  }) 
  trNode.find('[data-name]').on('paste',function(){
    setTimeout(()=>{
        this.innerHTML = this.innerText;
    }, 10);
  })  
  trNode.find('input').on('focus',function(){$(this).trigger('select')}) 
}


function checkUpdateOption(data){
  var 
    transactionToUpdate = getTransaction(data.metaId),
    worthDoingSomething = false;
  //check if something changed
  for(var name in data){
    var d = data[name],t= transactionToUpdate[name];
    if(d instanceof Date && t instanceof Date){
      if(d.getTime()!=t.getTime()){
        console.log(d,t)
        worthDoingSomething = true;
        break;
      }
    }else if(d!=t){
      worthDoingSomething = true;
      break;
    } 
  }
  if(!worthDoingSomething) return;
  
  if(transactionToUpdate.recurrencyDescriptor.recurrency==="NONE"){
    doitWithOption(data,"All")
    return;
  }
  ApiServer.budgettransactionupdateoption(data,function(options){
    if(options.length<2){
      doitWithOption(data,options[0])
    }else{
      modal.ask({
        title:'budget.updaterecurringtitle',
        message:'budget.updaterecurringtext',
        button:options.map(opt=>{return {value:opt,title:'budget.updaterecurring'+opt}})
      },function(opt){
        if(opt) doitWithOption(data,opt)
      });
    }
  })
}

function doitWithOption(data,option){
  ApiServer.budgettransactionput.prepare(option)(data)
}
